import { useBoolean, useMount } from 'react-use'

export type UseMountedResult = boolean

/**
 * `false` during the server render and the browser's first (hydration) render, `true` once the component has mounted.
 * Gate browser-only markup on it so the server HTML and the hydration render match.
 */
export const useMounted = (): UseMountedResult => {
  const [mounted, setMounted] = useBoolean(false)
  useMount(() => setMounted(true))
  return mounted
}
